import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import _isFunction from "lodash/isFunction";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.array.map.js";
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Modal, Button, Spinner, showError } from 'components/UI';
import { showApiError } from 'utils';
import { processIdCard } from 'services';
import { modalBody, modalHeader, zonesRow, uploadZoneStyle, zonePreview, zonePlaceholder, zoneIcon, zoneLabel, zoneActions, zoneBtn, zoneBtnClear, recognizeRow, resultsSection, resultsTitle, resultsTable, resultsTh, resultsTd, editInput, addressHint, footerRow } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
var DATE_FORMATS = ['DD.MM.YYYY', 'D.M.YYYY', 'YYYY-MM-DD', 'DD/MM/YYYY', 'D/M/YYYY'];

var parseDate = function parseDate(str) {
  if (!str) return null;
  var fmt = DATE_FORMATS.find(function (f) {
    return moment(str, f, true).isValid();
  });
  return fmt ? moment(str, fmt, true) : null;
};

var FIELD_LABELS = {
  first_name: 'Собствено (латиница)',
  middle_name: 'Бащино (латиница)',
  last_name: 'Фамилия (латиница)',
  first_name_bg: 'Собствено (кирилица)',
  middle_name_bg: 'Бащино (кирилица)',
  last_name_bg: 'Фамилия (кирилица)',
  egn: 'ЕГН',
  id_card_number: 'Номер на ЛК',
  date_of_birth: 'Дата на раждане',
  issue_date: 'Издадена на',
  valid_to_date: 'Валидна до',
  issuing_authority: 'Издадена от',
  address_area: 'Област',
  address_municipality: 'Община',
  address_city: 'Град/село',
  address_street: 'Улица',
  address_street_number: 'Улица №',
  address_quarter: 'Квартал',
  address_building: 'Блок',
  address_entrance: 'Вход',
  address_floor: 'Етаж',
  address_apartment: 'Апартамент'
};
var DISPLAY_FIELDS = Object.keys(FIELD_LABELS);

var UploadZone = function UploadZone(_ref) {
  var label = _ref.label,
      required = _ref.required,
      file = _ref.file,
      preview = _ref.preview,
      onFileChange = _ref.onFileChange;
  var fileRef = useRef();
  var cameraRef = useRef();

  var handleFileChange = function handleFileChange(e) {
    var _e$target$files;

    var picked = (_e$target$files = e.target.files) === null || _e$target$files === void 0 ? void 0 : _e$target$files[0]; // Reset the input so the same file can be re-selected after clearing

    e.target.value = '';
    if (picked) onFileChange(picked);
  };

  return ___EmotionJSX("div", {
    css: uploadZoneStyle(!!file)
  }, ___EmotionJSX("input", {
    ref: fileRef,
    type: "file",
    accept: "image/*",
    style: {
      display: 'none'
    },
    onChange: handleFileChange
  }), ___EmotionJSX("input", {
    ref: cameraRef,
    type: "file",
    accept: "image/*",
    capture: "environment",
    style: {
      display: 'none'
    },
    onChange: handleFileChange
  }), preview ? ___EmotionJSX("img", {
    src: preview,
    css: zonePreview,
    alt: label
  }) : ___EmotionJSX("div", {
    css: zonePlaceholder
  }, ___EmotionJSX("i", {
    className: "las la-id-card",
    css: zoneIcon
  }), ___EmotionJSX("span", {
    css: zoneLabel
  }, label, required && ' *')), ___EmotionJSX("div", {
    css: zoneActions
  }, ___EmotionJSX("button", {
    type: "button",
    css: zoneBtn,
    onClick: function onClick() {
      return cameraRef.current.click();
    },
    title: "\u041D\u0430\u043F\u0440\u0430\u0432\u0438 \u0441\u043D\u0438\u043C\u043A\u0430"
  }, ___EmotionJSX("i", {
    className: "las la-camera"
  }), " \u041A\u0430\u043C\u0435\u0440\u0430"), ___EmotionJSX("button", {
    type: "button",
    css: zoneBtn,
    onClick: function onClick() {
      return fileRef.current.click();
    },
    title: "\u0418\u0437\u0431\u0435\u0440\u0438 \u0444\u0430\u0439\u043B"
  }, ___EmotionJSX("i", {
    className: "las la-folder-open"
  }), " \u0424\u0430\u0439\u043B"), file && ___EmotionJSX("button", {
    type: "button",
    css: zoneBtnClear,
    onClick: function onClick() {
      return onFileChange(null);
    },
    title: "\u0418\u0437\u0447\u0438\u0441\u0442\u0438"
  }, ___EmotionJSX("i", {
    className: "las la-times"
  }))));
};

UploadZone.propTypes = {
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  file: PropTypes.object,
  preview: PropTypes.string,
  onFileChange: PropTypes.func.isRequired
};

var IdCardScanModal = function IdCardScanModal(_ref2) {
  var open = _ref2.open,
      onClose = _ref2.onClose,
      onApply = _ref2.onApply;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      frontFile = _useState2[0],
      setFrontFile = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      backFile = _useState4[0],
      setBackFile = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      frontPreview = _useState6[0],
      setFrontPreview = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      backPreview = _useState8[0],
      setBackPreview = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      loading = _useState10[0],
      setLoading = _useState10[1];

  var _useState11 = useState(null),
      _useState12 = _slicedToArray(_useState11, 2),
      result = _useState12[0],
      setResult = _useState12[1];

  var _useState13 = useState({}),
      _useState14 = _slicedToArray(_useState13, 2),
      edited = _useState14[0],
      setEdited = _useState14[1];

  var handleFileChange = function handleFileChange(side, file) {
    if (side === 'front') {
      setFrontFile(file);
      setFrontPreview(file ? URL.createObjectURL(file) : null);
    } else {
      setBackFile(file);
      setBackPreview(file ? URL.createObjectURL(file) : null);
    }

    setResult(null);
    setEdited({});
  };

  var handleRecognize = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var formData, _yield$processIdCard, _yield$processIdCard2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (frontFile) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", showError('Моля качете лицевата страна на личната карта.'));

            case 2:
              setLoading(true);
              formData = new FormData();
              formData.append('front_image', frontFile);
              if (backFile) formData.append('back_image', backFile);
              _context.next = 8;
              return processIdCard(formData);

            case 8:
              _yield$processIdCard = _context.sent;
              _yield$processIdCard2 = _slicedToArray(_yield$processIdCard, 2);
              res = _yield$processIdCard2[0];
              err = _yield$processIdCard2[1];
              setLoading(false);

              if (!err) {
                _context.next = 15;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 15:
              setResult(res);
              setEdited({});

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleRecognize() {
      return _ref3.apply(this, arguments);
    };
  }();

  var getValue = function getValue(field) {
    var _result$field;

    return field in edited ? edited[field] : (_result$field = result === null || result === void 0 ? void 0 : result[field]) !== null && _result$field !== void 0 ? _result$field : '';
  };

  var handleEdit = function handleEdit(field, value) {
    return setEdited(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, field, value));
    });
  };

  var handleApply = function handleApply() {
    if (!result) return;

    var merged = _objectSpread(_objectSpread({}, result), edited);

    var formValues = {
      egn: merged.egn || null,
      first_name: merged.first_name_bg || merged.first_name || null,
      middle_name: merged.middle_name_bg || merged.middle_name || null,
      last_name: merged.last_name_bg || merged.last_name || null,
      id_card_number: merged.id_card_number || null,
      id_card_issued_date: parseDate(merged.issue_date),
      id_card_valid_to_date: parseDate(merged.valid_to_date),
      id_card_issued_from: merged.issuing_authority || null,
      id_card_street: merged.address_street || null,
      id_card_street_number: merged.address_street_number || null,
      id_card_quarter: merged.address_quarter || null,
      id_card_building: merged.address_building || null,
      id_card_entrance: merged.address_entrance || null,
      id_card_floor: merged.address_floor || null,
      id_card_apartment: merged.address_apartment || null,
      id_card_area_id: merged.id_card_area_id || null,
      id_card_municipality_id: merged.id_card_municipality_id || null,
      id_card_city_id: merged.id_card_city_id || null,
      _municipalities: merged._municipalities || [],
      _cities: merged._cities || []
    };
    _isFunction(onApply) && onApply(formValues);
  };

  var hasAddressIds = result && (result.id_card_area_id || result.id_card_municipality_id || result.id_card_city_id);
  var missingAddressIds = result && (result.address_area || result.address_municipality || result.address_city) && !hasAddressIds;
  return ___EmotionJSX(Modal, {
    show: open,
    onClose: onClose,
    withoutClose: loading
  }, ___EmotionJSX("div", {
    css: modalBody
  }, ___EmotionJSX("div", {
    css: modalHeader
  }, ___EmotionJSX("i", {
    className: "las la-id-card"
  }), ___EmotionJSX("h4", null, "\u0421\u043A\u0430\u043D\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 \u043B\u0438\u0447\u043D\u0430 \u043A\u0430\u0440\u0442\u0430")), ___EmotionJSX("div", {
    css: zonesRow
  }, ___EmotionJSX(UploadZone, {
    label: "\u041B\u0438\u0446\u0435",
    required: true,
    file: frontFile,
    preview: frontPreview,
    onFileChange: function onFileChange(file) {
      return handleFileChange('front', file);
    }
  }), ___EmotionJSX(UploadZone, {
    label: "\u0413\u0440\u044A\u0431",
    file: backFile,
    preview: backPreview,
    onFileChange: function onFileChange(file) {
      return handleFileChange('back', file);
    }
  })), ___EmotionJSX("div", {
    css: recognizeRow
  }, ___EmotionJSX("div", {
    style: {
      position: 'relative',
      display: 'inline-block'
    }
  }, ___EmotionJSX(Spinner, {
    loading: loading,
    size: 24
  }), ___EmotionJSX(Button, {
    onClick: handleRecognize,
    disabled: !frontFile || loading
  }, ___EmotionJSX("i", {
    className: "las la-search",
    style: {
      marginRight: 6
    }
  }), "\u0420\u0430\u0437\u043F\u043E\u0437\u043D\u0430\u0439"))), result && ___EmotionJSX("div", {
    css: resultsSection
  }, ___EmotionJSX("p", {
    css: resultsTitle
  }, "\u0418\u0437\u0432\u043B\u0435\u0447\u0435\u043D\u0438 \u0434\u0430\u043D\u043D\u0438 \u2014 \u043F\u0440\u0435\u0433\u043B\u0435\u0434\u0430\u0439\u0442\u0435 \u0438 \u043A\u043E\u0440\u0438\u0433\u0438\u0440\u0430\u0439\u0442\u0435 \u043F\u0440\u0438 \u043D\u0443\u0436\u0434\u0430:"), missingAddressIds && ___EmotionJSX("div", {
    css: addressHint
  }, ___EmotionJSX("i", {
    className: "las la-exclamation-triangle",
    style: {
      marginRight: 6
    }
  }), "\u0410\u0434\u0440\u0435\u0441\u044A\u0442 \u043D\u0435 \u0431\u0435\u0448\u0435 \u043D\u0430\u043C\u0435\u0440\u0435\u043D \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E. \u041C\u043E\u043B\u044F \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u041E\u0431\u043B\u0430\u0441\u0442 / \u041E\u0431\u0449\u0438\u043D\u0430 / \u0413\u0440\u0430\u0434 \u0440\u044A\u0447\u043D\u043E \u043E\u0442 \u0444\u043E\u0440\u043C\u0443\u043B\u044F\u0440\u0430."), ___EmotionJSX("table", {
    css: resultsTable
  }, ___EmotionJSX("tbody", null, DISPLAY_FIELDS.map(function (field) {
    var val = getValue(field);
    return ___EmotionJSX("tr", {
      key: field
    }, ___EmotionJSX("td", {
      css: resultsTh
    }, FIELD_LABELS[field]), ___EmotionJSX("td", {
      css: resultsTd
    }, ___EmotionJSX("input", {
      css: editInput,
      value: val,
      onChange: function onChange(e) {
        return handleEdit(field, e.target.value);
      },
      placeholder: "\u2014"
    })));
  })))), ___EmotionJSX("div", {
    css: footerRow
  }, ___EmotionJSX(Button, {
    type: "secondary",
    onClick: onClose,
    disabled: loading,
    margin: "0 1em 0 0"
  }, "\u041E\u0442\u043A\u0430\u0436\u0438"), result && ___EmotionJSX(Button, {
    onClick: handleApply
  }, ___EmotionJSX("i", {
    className: "las la-check",
    style: {
      marginRight: 6
    }
  }), "\u041F\u043E\u043F\u044A\u043B\u043D\u0438 \u0444\u043E\u0440\u043C\u0443\u043B\u044F\u0440\u0430"))));
};

IdCardScanModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired
};
export default IdCardScanModal;